import { useMemo } from "react";
import { useStore } from "react-redux";

const SortenBezeichnung = (props) => {
  const { kennziffer, name } = props || {};
  const { currenciesStorage } = useStore().getState();

  const item = useMemo(() => {
    return currenciesStorage.getItems().find(m => Number(m.kennziffer) === Number(kennziffer)) || {};
  }, [kennziffer, currenciesStorage]);

  return item.name ? item.iso.toUpperCase() + " " + item.name : name || "";
};

export default SortenBezeichnung;
